import OfflineIcon from "@mui/icons-material/CloudOff";

import { useTranslation } from "~contexts/I18nContext/I18nContext";
import styles from "./OfflineNotice.module.scss";

export function OfflineNotice() {
  const t = useTranslation();

  return (
    <div className={styles.offlineNotice}>
      <span className={styles.icon}>
        <OfflineIcon />
      </span>
      <span>{t.timeWorkedOfflineNotice}</span>
    </div>
  );
}
